<div class="read-list">
    <div class="list-filter list-filter-tools" ng-show="showFilter">
        <div centuri-list-filter class="list-filter-elements" config="filterConfig" callback="filterCallback"></div>
    </div>
    <div id="managed-component"></div>
</div>
